import { ApiEndpoints } from "@shared/api/api-endpoints";
import { bxApiClient } from "@shared/api/clients/apiClientFactory";
import { QueryStringParameters } from "@shared/api/url-builder";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const getBillSummary = async (
  queryParams: Record<string, any> = {},
): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `bill-master-search/summary`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toString());

      Object.entries(queryParams).forEach(([key, value]) => {
        if (
          value !== undefined &&
          value !== null &&
          value !== "" &&
          key !== "page"
        ) {
          if (Array.isArray(value)) {
            if (value.length > 0) {
              qs.push(key, value.join(","));
            }
          } else {
            qs.push(key, value.toString());
          }
        }
      });
    },
  );

  try {
    const response = await bxApiClient.get(url);
    return response.data?.result;
  } catch (error) {
    console.error("Error fetching bill summary:", error);
    throw error;
  }
};

export const getBillList = async (
  queryParams: Record<string, any> = {},
  page?: number,
): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `bills-search`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
      if (page) {
        qs.push("page", page);
      }
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          if (Array.isArray(value)) {
            value.forEach((v) => {
              if (v !== undefined && v !== null && v !== "") {
                qs.push(key, v.toString());
              }
            });
          } else {
            qs.push(key, value.toString());
          }
        }
      });
    },
  );

  try {
    const response = await bxApiClient.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill list:", error);
    throw error;
  }
};

export const exportBillList = async (
  queryParams: Record<string, any> = {},
  page?: number,
): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `bills-search`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
      if (page) {
        qs.push("page", page);
      }
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          if (Array.isArray(value)) {
            value.forEach((v) => {
              if (v !== undefined && v !== null && v !== "") {
                qs.push(key, v.toString());
              }
            });
          } else {
            qs.push(key, value.toString());
          }
        }
      });
      qs.push("export_format", "csv");
    },
  );

  const response = await bxApiClient.get(url);

  return response.data;
};

export const downloadBillTemplate = async (billId: string): Promise<Blob> => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `render-dynamic-template/${billId}`,
  );
  const response = await bxApiClient.get(url, {
    responseType: "blob",
  });
  return response.data;
};

export const getBillCycleFrequency = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `choices/frequency`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    },
  );
  const response = await bxApiClient.get(url);

  const data = response.data?.result;
  return data.map((item: any) => ({
    value: item.key,
    label: item.value,
  }));
};

export const getPremiseList = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();

  const url = ApiEndpoints.createUrlWithQueryParameters(
    "onboarding",
    "config-map/territory_json",
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
      qs.push("config_level", "premise");
    },
  );

  const response = await bxApiClient.get(url);
  const data = response.data?.result;
  return data.map((item: any) => ({
    value: item.code,
    label: item.name,
  }));
};

export const getBillCycleList = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "bx",
    `run-list-dropdown`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID);
    },
  );
  const response = await bxApiClient.get(url);

  const data = response.data?.result;
  return data.map((item: any) => ({
    id: item.id,
    name: item.name,
  }));
};
